export default __webpack_public_path__ + "static/media/8.11137862.svg";